import { createAction } from '@reduxjs/toolkit';
//import { ErrorObject } from '../StoreConstants';
import { UserPropType } from './InitialState';

const Types = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
}

const Creators = {
  login: createAction<UserPropType>(Types.LOGIN),
  logout: createAction(Types.LOGOUT),
}

export { Types };
export default Creators;